import { pushDataLayerClick } from '../shared/utils';
export const useTrackedButton = _ref => {
  let {
    trackingState: {
      trackFirstInteraction,
      toolInfo
    },
    trackingName,
    onClick
  } = _ref;
  const handleClick = e => {
    pushDataLayerClick({
      toolInfo,
      itemText: `${trackingName} (button)`
    });
    trackFirstInteraction();
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };
  return {
    onClick: handleClick
  };
};

///////// IMPLEMENTATION /////////

// TODO: Switch to MouseEventHandler when supported by Seatbelt - CTX-1312